export default {
  setUserInfo(state, payload) {
    state.userInfo = payload
  },
  setActiveMenu(state, payload) {
    state.activeMenu = payload
  },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js